import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IrisTimeFormatI } from '../models/IrisTimeFormat';

@Injectable({
  providedIn: 'root',
})
export class IrisTimeService {
  private readonly httpClient = inject(HttpClient);

  getTimeFormats(): Observable<IrisTimeFormatI[]> {
    return this.httpClient.get<IrisTimeFormatI[]>(`/security/datetimeformat`);
  }
}
